import { api } from '../client/axiosClient';
import { CustomResponseEntity, PaginationParams } from '../types/common';

export class BaseService<T, CreateDto = Omit<T, 'id'>, UpdateDto = Partial<CreateDto>> {
  constructor(protected baseUrl: string) {}

  findAll(params?: PaginationParams): Promise<CustomResponseEntity<T[]>> {
    return api.get(this.baseUrl, { params });
  }

  findById(id: string): Promise<CustomResponseEntity<T>> {
    return api.get(`${this.baseUrl}/${id}`);
  }

  create(data: CreateDto): Promise<CustomResponseEntity<T>> {
    return api.post(this.baseUrl, data as Record<string, unknown>);
  }

  update(id: string, data: UpdateDto): Promise<CustomResponseEntity<T>> {
    return api.put(`${this.baseUrl}/${id}`, data as Record<string, unknown>);
  }

  delete(id: string): Promise<CustomResponseEntity<void>> {
    return api.delete(`${this.baseUrl}/${id}`);
  }

  get(endpoint: string): Promise<CustomResponseEntity<any>> {
    return api.get(`${this.baseUrl}${endpoint}`);
  }
} 